import { render, staticRenderFns } from "./AuthLayoutWrapper.vue?vue&type=template&id=2acdb2d6&scoped=true"
var script = {}
import style0 from "./AuthLayoutWrapper.vue?vue&type=style&index=0&id=2acdb2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdb2d6",
  null
  
)

export default component.exports